import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class FanService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation FAN_UPDATE(
          $id: String!
          $data: FanInput!
        ) {
          fanUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.fanUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation FAN_DESTROY($ids: [String!]!) {
          fanDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.fanDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation FAN_CREATE($data: FanInput!) {
          fanCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.fanCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation FAN_IMPORT(
          $data: FanInput!
          $importHash: String!
        ) {
          fanImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.fanImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query FAN_FIND($id: String!) {
          fanFind(id: $id) {
            id
            name
            lastName
            picture {
              id
              name
              sizeInBytes
              publicUrl
              privateUrl
            }
            uid
            teams {
              id
            }
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.fanFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query FAN_LIST(
          $filter: FanFilterInput
          $orderBy: FanOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          fanList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              name
              lastName
              picture {
                id
                name
                sizeInBytes
                publicUrl
                privateUrl
              }
              uid
              teams {
                id
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.fanList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query FAN_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          fanAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.fanAutocomplete;
  }
}
